"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var checkSvgPath = 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';
var closeSvgPath = 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z';

var IconCircleOutline = function IconCircleOutline(_ref) {
  var color = _ref.color,
      error = _ref.error;
  return (0, _core.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, (0, _core.jsx)("path", {
    d: error ? closeSvgPath : checkSvgPath,
    fill: color
  }));
};

IconCircleOutline.defaultProps = {
  color: '#ffffff',
  error: false
};
IconCircleOutline.propTypes = {
  color: _propTypes["default"].string,
  error: _propTypes["default"].bool
};
var _default = IconCircleOutline;
exports["default"] = _default;

//# sourceMappingURL=IconCircleOutline.js.map